module.exports = __webpack_public_path__ + "static/img/16.d910418.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/loading/img/16.png
// module id = LwmA
// module chunks = 0